<template>
  <ChatClient/>
</template>

<script>
import ChatClient from './components/ChatClient.vue'

export default {
  name: 'App',
  components: {
    ChatClient
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
